<template>
  <div class="qr-custom" style="width: 2cm; height: 2cm; margin: 0 auto; float: right; position: relative;margin-top: 2px !important;">
    <QrcodeVue :logoSrc="logoUrl" :text="codeValue" :logoScale="logoSize" :size="codeSize" :margin="0"/>
  </div>
</template>

<script>
import QrcodeVue from 'vue-qr'
export default {
  props: {
    logoUrl: {
      type: String,
      default: ''
    },
    logoSize: Number,
    codeValue: String,
    codeSize: Number
  },
  components: {
    QrcodeVue
  }
}
</script>